// /api/native.js
// 使用 preload 暴露的白名单 API：window.native.*
// 统一 Promise 化调用 + 主→渲染推送订阅（无任何 chrome.send / window.cr 依赖）

/** —— 请求-响应 —— **/
export const getBrowserVersion = () => window.native.getBrowserVersion()
export const getRunningBrowser = () => window.native.getRunningBrowser()
export const launchBrowser = item => window.native.launchBrowser(item)
export const deleteBrowser = browserId => window.native.deleteBrowser(browserId)
export const closeBrowser = browserId => window.native.closeBrowser(browserId) // 新增：关闭实例


/** —— 订阅主进程推送（launchState）——
 *  返回解绑函数，请在组件销毁时调用避免泄漏
 *  payload: { browserId, running, code?, signal? }
 */
export function onLaunchState(cb) {
  if (typeof cb !== 'function') return () => {}
  return window.native.onLaunchState(cb)
}

// 生成UUID的辅助函数
export function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
